const cache = new Map();

const ensureRecord = (url) => {
  if (!cache.has(url)) {
    cache.set(url, { status: "idle", img: null, err: null, promise: null });
  }
  return cache.get(url);
};

export const requestImage = (url) => {
  if (!url) return;
  const rec = ensureRecord(url);
  if (rec.status === "loaded" || rec.status === "loading" || rec.status === "error") return;

  rec.status = "loading";
  rec.promise = new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = (e) => reject(e);
    img.src = url;
  })
    .then((img) => {
      rec.status = "loaded";
      rec.img = img;
      return img;
    })
    .catch((err) => {
      rec.status = "error";
      rec.err = err;
      return null;
    });
};

export const getImageRecord = (url) => {
  if (!url) return { status: "idle", img: null };
  const rec = ensureRecord(url);
  return { status: rec.status, img: rec.img };
};

